<template>
  <v-sheet class="login responsive-sheet">
    <div class="inside">
      <v-form v-model="valid" fast-fail @submit.prevent="handleSubmit">
        <v-text-field
          v-model="username"
          label="Usuario"
          variant="solo"
          :rules="obligatorio"
          class="asterisco"
        >
        <template #message>
          <span v-if="!valid" class="custom-error-message">Este campo es obligatorio.</span>
        </template>
        </v-text-field>
        <v-text-field
          v-model="password"
          label="Contraseña"
          variant="solo"
          :type="show ? 'text' : 'password'"
          :append-inner-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append-inner="show = !show"
          :rules="passwordRules"
          class="asterisco"
        >
        <template #message>
          <span v-if="!valid" class="custom-error-message">Este campo es obligatorio.</span>
        </template>
        </v-text-field>
        <v-btn type="submit" block color="#bec0b5" :disabled="!valid">Ingresá</v-btn>

        <v-row class="mt-4" justify="center" align="center">
          <p style="color: whitesmoke;"><v-icon>mdi-help-circle</v-icon>
            <a @click="this.$router.push('/mesa-de-ayuda/')" style="text-decoration: underline; cursor: pointer;">¿Necesitás ayuda?
            </a>
          </p>
        </v-row>
        <v-container class="d-flex justify-center align-center">
          <Loader v-if="cargando"></Loader>
        </v-container>
      </v-form>
    </div>
  </v-sheet>
  <AlertComponent
      :title="alertTitle"
      :text="alertText"
      :alertType="alertType"
      :showAlert="showAlert"
      @close="showAlert = false"
    />
</template>

<style scoped>
.login {
  background-image: url(../../public/register-bg.jpg);
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-color: #bec0b5;
  border-radius: 12px;
}
.responsive-sheet {
  width: 25%;
}
@media (max-width: 810px) {
  .responsive-sheet {
    width: 70%;
  }
}
.inside {
  padding: 7%;
}
.custom-error-message {
  color: rgb(228, 253, 226);
  font-size: 14px;
  margin-left: 4px;
}
.asterisco label::after {
    content: ' *'; 
    color: red;    
    margin-left: 4px;
    font-size: inherit; 
}
</style>

<script>
/* eslint-disable */
import "sweetalert2/dist/sweetalert2.min.css";
import AuthService from "@/api/AuthService";
import AlertComponent from "@/components/AlertComponent.vue"
import Loader from "./Loader.vue";
import { obligatorio } from "@/_helpers/rules";

export default {
  components: {
    AlertComponent,
    Loader
  },
  data() {
    return {
      valid: false,
      authService: new AuthService(),
      cargando: false,
      username: "",
      password: "",
      show: false,
      showAlert:false,
      alertTitle: 'Error',
      alertText: 'Credenciales inválidas.',
      alertType: 'error',
      obligatorio: obligatorio,
      passwordRules: [
        (value) => {
          if (value?.length > 0) return true;
          return "Debe ingresar una contraseña.";
        },
      ],
    };
  },
  methods: {
    async handleSubmit() {
      this.cargando = true;
      const res = await this.$store.dispatch("login",{email:this.username, password:this.password});
      this.cargando = false;
      switch (res) {
        case "blocked":
          this.alertTitle = "Error";
          this.alertText = "El usuario se encuentra bloqueado.";
          this.alertType = "error"
          this.triggerAlert();
          break;
        case "invalid":
          this.alertTitle = "Error";
          this.alertText = "Credenciales inválidas.";
          this.alertType = "error"
          this.triggerAlert();
          break;
        default:
          const primerLogin = res.firstLogin;
          if(primerLogin){
            this.$router.push({ name: "cambiar-contrasenia", query: { primerLogin: true } });
          } else{
            this.$router.push({ name: "eleccion-modo" });
          }
          break;
      }
    },
    triggerAlert() {
      this.showAlert = true;
    }
  },
};
</script>
